const clone = require('lodash/clone');
const remove = require('lodash/remove');
const extend = require('lodash/extend');

const autobind = require('@ordergroove/brandy/src/utils/auto-bind');

const defaultToastConfig = {
  timeout: 5000,
  close: true
};

const inject = ['$timeout', '$translate', '$log'];

function ToastServiceFactory($timeout) {
  class ToastService {
    constructor(toasts = []) {
      this.toasts = toasts;
    }

    get toasts() {
      return this._toasts;
    }

    set toasts(toasts) {
      this._toasts = toasts;
    }

    clear() {
      this._toasts = [];
    }

    /**
     * Add a toast message:
     * @param toast: the toast message to show it has the following properties:
     *    .msg:     The body of the toast. It will be displayed in paragraph form.
     *    .type:    The type of toast, can be on of ['info', 'success', 'warn', 'danger']. This will (TODO) determin
     *                    certain styling with of the toast to fit their description.
     *
     * @param config: configuration options for displaying the toast. Default: close only
     *    .close:   If true, a close button appear on the toast. Clicking on it will remove the toast.
     *              Can be used in tandem with 'timeout'.
     *    .timeout: Number of milliseconds to wait before closing the toast. 0 means don't close.
     *              Can be used in tandem with 'close'.
     */
    add(_toast, config = defaultToastConfig) {
      const toast = clone(_toast);
      if (toast) {
        const close = this.remove.bind(this, toast);

        if (config.close) {
          toast.close = close;
        }

        if (config.timeout > 0) {
          toast.timeout = $timeout(close, config.timeout);
        }

        this.toasts.push(toast);
      }
    }

    success(msg, config) {
      this.add({ msg: msg, type: 'success' }, config);
    }

    info(msg, config) {
      this.add({ msg: msg, type: 'info' }, config);
    }

    warn(msg, config) {
      this.add({ msg: msg, type: 'warn' }, config);
    }

    danger(msg, config) {
      this.add({ msg: msg, type: 'danger' }, config);
    }

    remove(toast) {
      remove(this.toasts, it => it === toast);
    }
  }

  class ToastTranslateService extends ToastService {
    /**
     * Add a translated toast message. Refer to what the base class does. Everything is the same except:
     *    toast.msg:     The translation key to be translated. It will be displayed in paragraph form.
     *    params:        The values to be plugged into the translation.
     */
    add(toast, params = {}, config) {
      super.add(extend(toast, { translate: true, translateParams: params }), config);
    }
  }

  const service = new ToastService();
  service.translate = autobind(new ToastTranslateService(service.toasts));

  return autobind(service);
}


ToastServiceFactory.$inject = inject;

module.exports = ToastServiceFactory;
